<template>
  <div class="audit-summary">
    <div v-for="card in cards" :key="card.key" class="audit-summary-card">
      <span class="audit-summary-icon" :class="card.tone">
        <i :class="card.icon"></i>
      </span>
      <div class="audit-summary-text">
        <span class="audit-summary-label">{{ card.label }}</span>
        <span v-if="loading" class="audit-summary-skeleton"></span>
        <span v-else class="audit-summary-value">{{ formatCount(summary[card.key]) }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  summary: {
    type: Object,
    default: () => ({})
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const cards = [
  { key: 'total_records', label: 'Total Records', icon: 'fa-solid fa-layer-group', tone: 'is-primary' },
  { key: 'never_modified', label: 'Never Modified', icon: 'fa-solid fa-circle-check', tone: 'is-success' },
  { key: 'modified', label: 'Modified', icon: 'fa-solid fa-pen-to-square', tone: 'is-warning' },
  { key: 'creators', label: 'Creators', icon: 'fa-solid fa-user-plus', tone: 'is-info' },
  { key: 'updaters', label: 'Updaters', icon: 'fa-solid fa-user-pen', tone: 'is-muted' }
]

const formatCount = (value) => {
  if (! value) return 0
  return Number(value).toLocaleString('en-IN')
}
</script>

<style scoped>
.audit-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}
.audit-summary-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid #eaecf0;
  border-radius: 10px;
  background: #fff;
}
.audit-summary-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 38px;
  height: 38px;
  border-radius: 10px;
  font-size: 15px;
}
.audit-summary-icon.is-primary {
  background: #f4f3ff;
  color: #7367f0;
}
.audit-summary-icon.is-success {
  background: #ecfdf3;
  color: #039855;
}
.audit-summary-icon.is-warning {
  background: #fffaeb;
  color: #dc6803;
}
.audit-summary-icon.is-info {
  background: #eff8ff;
  color: #1570ef;
}
.audit-summary-icon.is-muted {
  background: #f2f4f7;
  color: #475467;
}
.audit-summary-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.audit-summary-label {
  font-size: 12px;
  font-weight: 500;
  color: #667085;
}
.audit-summary-value {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.3;
  color: #101828;
}
.audit-summary-skeleton {
  display: block;
  width: 64px;
  height: 22px;
  margin-top: 2px;
  border-radius: 6px;
  background: linear-gradient(90deg, #f2f4f7 25%, #e4e7ec 50%, #f2f4f7 75%);
  background-size: 200% 100%;
  animation: audit-shimmer 1.2s infinite;
}
@keyframes audit-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
